module.exports = __webpack_public_path__ + "img/garden-m.1c8562bb.jpg";